<template>
  <b-form @submit.prevent>
    <div class="white-section box-info pt-3 mb-2">
      <section class="box-has-title mb-3">
        <input type="password" autocomplete="off" hidden />
        <input type="text" autocomplete="off" hidden />
        <b-row>
          <b-col xl="2" lg="3" md="4" sm="6">
            <b-form-group
              :label="$t('user.gender')"
              label-for="user-gender"
              :invalid-feedback="
                invalidFeedbackGender
                  ? $t(`validation.${invalidFeedbackGender}`, {
                      field: $t('user.gender'),
                    })
                  : ''
              "
              :class="{ 'required-group': !$v.userToEdit.gender.required }"
              :state="
                $v.userToEdit.gender.$dirty
                  ? !$v.userToEdit.gender.$invalid === false
                    ? false
                    : null
                  : null
              "
            >
              <b-form-radio-group
                :state="
                  $v.userToEdit.gender.$dirty
                    ? !$v.userToEdit.gender.$invalid === false
                      ? false
                      : null
                    : null
                "
                ref="gender"
                v-model="userToEdit.gender"
                :options="genders"
                id="user-gender"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col xl="2" lg="3" md="4" sm="6">
            <b-form-group
              :invalid-feedback="invalidUserName(invalidFeedbackUsername)"
              :state="
                $v.userToEdit.username.$dirty
                  ? !$v.userToEdit.username.$invalid === false
                    ? false
                    : null
                  : null
              "
              :label="$t('user.username')"
              label-for="user-username"
              :class="{ 'required-group': !$v.userToEdit.username.required }"
              dir="ltr"
            >
              <b-form-input
                @keypress="onlyEnglish($event)"
                @input="$v.userToEdit.username.$touch()"
                :state="
                  $v.userToEdit.username.$dirty
                    ? !$v.userToEdit.username.$invalid === false
                      ? false
                      : null
                    : null
                "
                aria-describedby="user-username-feedback"
                id="user-username"
                v-model="userToEdit.username"
                readonly
                onfocus="this.removeAttribute('readonly');"
              />
            </b-form-group>
          </b-col>
          <b-col xl="2" lg="3" md="4" sm="6">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackFirstName
                  ? $t(`validation.${invalidFeedbackFirstName}`, {
                      field: $t('user.firstName'),
                    })
                  : ''
              "
              :state="
                $v.userToEdit.firstName.$dirty
                  ? !$v.userToEdit.firstName.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{ 'required-group': !$v.userToEdit.firstName.required }"
              :label="$t('user.name')"
              label-for="user-first-name"
            >
              <b-form-input
                @keydown="preventNumbers($event)"
                :state="
                  $v.userToEdit.firstName.$dirty
                    ? !$v.userToEdit.firstName.$invalid
                    : null
                "
                id="user-first-name"
                v-model="userToEdit.firstName"
              />
            </b-form-group>
          </b-col>
          <b-col xl="2" lg="3" md="4" sm="6">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackLastName
                  ? $t(`validation.${invalidFeedbackLastName}`, {
                      field: $t('user.lastName'),
                    })
                  : ''
              "
              :state="
                $v.userToEdit.lastName.$dirty
                  ? !$v.userToEdit.lastName.$invalid === false
                    ? false
                    : null
                  : null
              "
              :label="$t('user.lastName')"
              label-for="user-lastname"
              :class="{ 'required-group': !$v.userToEdit.lastName.required }"
            >
              <b-form-input
                @keydown="preventNumbers($event)"
                @input="$v.userToEdit.lastName.$touch()"
                :state="
                  $v.userToEdit.lastName.$dirty
                    ? !$v.userToEdit.lastName.$invalid === false
                      ? false
                      : null
                    : null
                "
                aria-describedby="user-lastname-feedback"
                id="user-lastname"
                v-model="userToEdit.lastName"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="3" xl="2">
            <b-form-group
              :label="$t('user.fathersName')"
              label-for="user-fatherName"
            >
              <div class="form-label-group">
                <b-form-input
                  id="user-fatherName"
                  v-model="userToEdit.fatherName"
                 />
              </div>
            </b-form-group>
          </b-col>
          <b-col xl="2" lg="3" md="4" sm="6">
            <b-form-group
              :state="
                $v.userToEdit.roles.$dirty
                  ? !$v.userToEdit.roles.$invalid === false
                    ? false
                    : null
                  : null
              "
              :invalid-feedback="
                invalidFeedbackRole
                  ? $t(`validation.${invalidFeedbackRole}`)
                  : ''
              "
              :label="$t('user.role')"
              label-for="user-role"
            >
              <my-v-select
                v-if="roles"
                translateObj="role"
                :translate="true"
                v-model="userToEdit.roles"
                :concat-label="['title']"
                :options="roles.length ? roles : null"
                :multiple="true"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackUnit
                  ? $t(`validation.${invalidFeedbackUnit}`, {
                      field: $t('user.unit'),
                    })
                  : ''
              "
              :label="$t('user.unit')"
              :state="
                $v.userToEdit.units.$dirty
                  ? !$v.userToEdit.units.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{
                'required-group': !$v.userToEdit.units.required,
              }"
              label-for="count-of-queue"
            >
              <my-v-select
                v-if="units"
                :options="units"
                v-model="userToEdit.units"
                custom-class="w-100 mr-2"
                :concat-label="['title']"
                :multiple="true"
              />
            </b-form-group>
          </b-col>
          <b-col xl="2" lg="3" md="4" sm="6">
            <b-form-group
              :label="$t('user.nationality')"
              label-for="user-nationality"
            >
              <my-v-select
                :key="userToEdit.countryId"
                id="user-nationality"
                v-if="countries"
                v-model="userToEdit.countryId"
                :multiple="false"
                :options="countries && countries.length ? countries : []"
                :translate="false"
                :concat-label="['title.fa']"
                @input="countrySelected"
                :searchable="true"
                :filterable="true"
              />
            </b-form-group>
          </b-col>
          <b-col xl="2" lg="3" md="4" sm="6">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackNationalCode
                  ? $t(`validation.${invalidFeedbackNationalCode}`, {
                      field: $t('user.nationalCode'),
                    })
                  : ''
              "
              :label="$t('user.nationalCode')"
              label-for="user-nationalcode"
              :state="
                $v.userToEdit.nationalCode.$dirty
                  ? !$v.userToEdit.nationalCode.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{
                'required-group': !$v.userToEdit.nationalCode.required,
              }"
            >
              <b-form-input
                @keypress="preventNationalType($event)"
                @input="$v.userToEdit.nationalCode.$touch()"
                :state="
                  $v.userToEdit.nationalCode.$dirty
                    ? !$v.userToEdit.nationalCode.$invalid === false
                      ? false
                      : null
                    : null
                "
                aria-describedby="user-nationalcode-feedback"
                v-model="userToEdit.nationalCode"
                id="user-nationalcode"
                dir="ltr"
                type="text"
                maxlength="10"
              />
            </b-form-group>
          </b-col>
          <b-col xl="2" lg="3" md="4" sm="6">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackMobile
                  ? $t(`validation.${invalidFeedbackMobile}`, {
                      field: $t('user.mobile'),
                      current: $t('user.anotherMobile'),
                      min: 11,
                    })
                  : ''
              "
              :label="$t('user.mobile')"
              :state="
                $v.userToEdit.mobile.$dirty
                  ? !$v.userToEdit.mobile.$invalid === false
                    ? false
                    : null
                  : null
              "
              label-for="user-mobile"
            >
              <!-- :state="$v.mobiles.$dirty ? !$v.mobile.$invalid : null" -->
              <!-- :state="$v.mobile.$dirty ? !$v.mobile.$invalid : null" -->
              <b-form-input
                @keypress="preventMobileType($event)"
                aria-describedby="user-mobile-help"
                v-model="userToEdit.mobile"
                :state="
                  $v.userToEdit.mobile.$dirty
                    ? !$v.userToEdit.mobile.$invalid === false
                      ? false
                      : null
                    : null
                "
                id="user-mobile"
                dir="ltr"
              />
              <b-form-text id="user-mobile-help"
                >{{ $t("hint.mobile") }}
              </b-form-text>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :label="$t('user.dialCode')"
              label-for="user-mobile-dialcode"
            >
              <v-select
              :items="countriesWithCode"
              v-model="mobileCountryId"
              item-text="titleAndCode"
              item-value="_id"
              @input="countrySelected"
              attach
              class="selectCountri"
            >
            <template v-slot:selection="{ item }">
              <img :src="item.wikipedia_image" style="width:20px; height:20px; margin-right:10px ; margin-left:10px">
              {{ item.phoneCode }}
            </template>
              <template v-slot:item="{ item }">
                <img :src="item.wikipedia_image" style="width:20px; height:20px; margin-right:10px ; margin-left:10px">
                {{ item.phoneCode }}
              </template>
            </v-select>
            </b-form-group>

          </b-col>
          <!-- Item Mobile -->
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackSpeciality
                  ? $t(`validation.${invalidFeedbackSpeciality}`, {
                      field: $t('user.medicalSpecialtyId'),
                    })
                  : ''
              "
              :label="$t('user.medicalSpecialtyId')"
              label-for="user-speciality"
              :state="
                $v.userToEdit.medicalSpecialtyId.$dirty
                  ? !$v.userToEdit.medicalSpecialtyId.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{
                'required-group': !$v.userToEdit.medicalSpecialtyId.required,
              }"
            >
              <my-v-select
                :key="medicalSpecialtyId"
                id="user-speciality"
                v-if="medicalSpecialties && medicalSpecialties.length > 0"
                :translate="false"
                v-model="userToEdit.medicalSpecialtyId"
                :concat-label="['title']"
                :options="medicalSpecialties.length ? medicalSpecialties : []"
                :multiple="false"
                :searchable="true"
                :filterable="true"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </section>
    </div>
    <div class="white-section">
      <b-row>
        <!-- submit and reset -->
        <b-col class="text-right" md="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size=""
            type="submit"
            variant="info"
            @click="editUser"
          >
            {{ $t("general.submit") }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-form>
</template>

<script>
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
import dateFormat from "@/mixins/dateFormat";
import datePicker from "@alireza-ab/vue-persian-datepicker";
import onlyEnglish from "@/mixins/onlyEnglish";
import nationalCodeValidation from "@/mixins/validations/nationalCode";
import mobileRepeaterBasic from "@/components/user/mobile-repeater/MobileRepeaterBasic";
import mobileValidation from "@/mixins/validations/mobile";
import postalCodeValidation from "@/mixins/validations/postalCode";
import addressRepeaterBasic from "@/components/user/address-repeater/AddressRepeaterBasic";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
import phoneRepeaterBasic from "@/components/user/phone-repeater/PhoneRepeaterBasic";
import userSpouseRepeater from "@/components/user/user-spouse-repeater/UserSpouseRepeater.vue";
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker.vue";
import moment from "jalali-moment";

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormSelect,
  BFormInvalidFeedback,
  BFormSelectOption,
  BFormRadioGroup,
  BFormText,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapGetters } from "vuex";
import filterRoles from "@/mixins/filterRoles";
// import medicalSpecialties from "@/store/medicalSpecialties";
import Section from "@/views/baseInfo/structure/sections/Section";
import DoctorInfoSection from "@/components/user/doctor/DoctorInfoSection";
import DoctorAccountInfo from "@/components/user/doctor/DoctorAccountInfo";
import NurseAndMidwifeInfo from "@/components/user/nurse/NurseAndMidwifeInfo";
import ForeignerInfo from "@/components/user/Foreigner/ForeignerInfo";
import legalExpert from "@/components/user/legalExpert/LegalExpert";
import MyCleaveDate from "@/components/wrapper/datePicker/MyCleaveDate.vue";

export default {
  components: {
    ForeignerInfo,
    NurseAndMidwifeInfo,
    DoctorAccountInfo,
    DoctorInfoSection,
    Section,
    MyVSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BFormInvalidFeedback,
    mobileRepeaterBasic,
    addressRepeaterBasic,
    phoneRepeaterBasic,
    BFormSelectOption,
    BFormRadioGroup,
    BFormText,
    userSpouseRepeater,
    datePicker,
    MyAbDatePicker,
    legalExpert,
    MyCleaveDate,
  },
  directives: {
    Ripple,
  },
  created() {
    this.$store.commit("user/RESET_MODULE");
    let params = this.$route.params;
    // this.$store.dispatch("getRoles").then((roles) => {
    //   // console.log("getRoles", roles);
    //   this.role = roles[0]._id;
    // });

    let parent = this;
    this.$store.dispatch("user/findUser", params.id).then((user) => {
      this.pushBreadcrumb({
        text: "editUser",
        to: { name: "editUser" },
        translate: true,
      });
      this.pushBreadcrumb({
        text: user.firstName + " " + user.lastName,
        translate: false,
      });
      this.setCurrentBreadcrumb([
        {
          text: "editUser",
          to: { name: "editUser" },
          translate: true,
        },
        { text: user.firstName + " " + user.lastName, translate: false },
      ]);
      this.$store.commit("user/SET_USER_TO_EDIT", user);
      this.$store.dispatch("medicalSpecialties/getActiveMedicalSpecialty");
      this.$store.dispatch("location/countries").then((countries) => {
      let iran = countries.find((c) => c["alpha_2"] === "IR")._id;
      this.country = iran;
      this.mobileCountryId = iran;
      this.countrySelected();
    });
      this.$store.dispatch("units/searchUnit", {
        status:"active"
      });
    });
    this.$store.commit("SET_IS_LOADING", false);
  },
  mixins: [
    nationalCodeValidation,
    dateFormat,
    mobileValidation,
    postalCodeValidation,
    onlyEnglish,
    filterRoles,
  ],
  validations() {
    return {
      userToEdit: {
        gender: {
          required,
        },
        nationalCode: {
          required,
          maxLength: maxLength(10),
          nationalCodeValidation: (value) => this.nationalCodeValidation(value),
        },
        lastName: {
          required,
        },
        firstName: {
          required,
        },
        username: {
          required,
          minLength: minLength(4),
        },
        roles: {
          onlyPatient: () => {
            return !(
              this.userToEdit.roles.find((r) => {
                return r === this.filterRoles("patient");
              }) && this.userToEdit.roles.length === 1
            );
          },
        },
        mobile: {
          required,
          minLength: minLength(11),
        },
        medicalSpecialtyId: {
          required: requiredIf(() => {
            return this.userToEdit.roles.find(
              (r) => r === this.filterRoles("doctor")
            );
          }),
        },
        units: {
          required,
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      genders: "user/genders",
      valid: "validation/valid",
      countries: "location/countries",
      roles: "roles",
      units: "units/units",
      medicalSpecialties: "medicalSpecialties/medicalSpecialties",
    }),
    userToEdit: {
      set(userToEdit) {
        this.$store.commit("user/SET_USER_TO_EDIT", userToEdit);
      },
      get() {
        return this.$store.getters["user/userToEdit"];
      },
    },
    roleFilter: {
      set(role) {
        this.$store.commit("user/SET_ROLE_FILTER", role);
      },
      get() {
        return this.$store.getters["user/roleFilter"];
      },
    },
    firstName: {
      set(name) {
        this.$store.commit("user/SET_FIRSTNAME", name);
      },
      get() {
        return this.$store.getters["user/firstName"];
      },
    },
    lastName: {
      set(lastName) {
        this.$store.commit("user/SET_LASTNAME", lastName);
      },
      get() {
        return this.$store.getters["user/lastName"];
      },
    },
    username: {
      set(username) {
        this.$store.commit("user/SET_USERNAME", username);
      },
      get() {
        return this.$store.getters["user/username"];
      },
    },
    fatherName: {
      set(fatherName) {
        this.$store.commit("user/SET_FATHERNAME", fatherName);
      },
      get() {
        return this.$store.getters["user/fatherName"];
      },
    },
    password: {
      set(password) {
        this.$store.commit("user/SET_PASSWORD", password);
      },
      get() {
        return this.$store.getters["user/password"];
      },
    },
    confirm: {
      set(confirm) {
        this.$store.commit("user/SET_CONFIRM", confirm);
      },
      get() {
        return this.$store.getters["user/confirm"];
      },
    },
    nationalCode: {
      set(nationalCode) {
        this.$store.commit("user/SET_NATIONALCODE", nationalCode);
      },
      get() {
        return this.$store.getters["user/nationalCode"];
      },
    },
    mobile: {
      set(mobile) {
        this.$store.commit("user/SET_MOBILE", mobile);
      },
      get() {
        return this.$store.getters["user/mobile"];
      },
    },
    mobileCountryId: {
      set(mobileCountryId) {
        this.$store.commit("user/SET_MOBILE_COUNTRY_ID", mobileCountryId);
      },
      get() {
        return this.$store.getters["user/mobileCountryId"];
      },
    },
    country: {
      set(country) {
        // console.log(country);
        this.$store.commit("user/SET_COUNTRY", country);
      },
      get() {
        // console.log(this.$store.getters["user/country"]);
        return this.$store.getters["user/country"];
      },
    },
    gender: {
      set(gender) {
        this.$store.commit("user/SET_GENDER", gender);
      },
      get() {
        return this.$store.getters["user/gender"];
      },
    },
    roleFilter: {
      set(role) {
        this.$store.commit("user/SET_ROLE_FILTER", role);
      },
      get() {
        return this.$store.getters["user/roleFilter"];
      },
    },
    medicalSpecialtyId: {
      set(medicalSpecialtyId) {
        this.$store.commit("user/SET_MEDICAL_SPECIALTY_ID", medicalSpecialtyId);
      },
      get() {
        return this.$store.getters["user/medicalSpecialtyId"];
      },
    },
    invalidFeedbackGender: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.userToEdit.gender.$dirty) return error;
        if (!this.$v.userToEdit.gender.required) error = "required";
        return error;
      },
    },
    invalidFeedbackRole: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.userToEdit.roles.$dirty) return error;
        if (!this.$v.userToEdit.roles.onlyPatient)
          error = "cannotAddPatientInAddUser";

        return error;
      },
    },
    invalidFeedbackNationalCode: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.userToEdit.nationalCode.$dirty) return error;
        if (!this.$v.userToEdit.nationalCode.required) {
          error = "required";
          return error;
        }
        if (!this.$v.userToEdit.nationalCode.nationalCodeValidation) {
          error = "invalid";
          return error;
        }
        return error;
      },
    },
    invalidFeedbackMobile: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.userToEdit.mobile.$dirty) return error;
        if (!this.$v.userToEdit.mobile.required) {
          error = "required";
          return error;
        }
        if (!this.$v.userToEdit.mobile.minLength) {
          error = "min";
          return error;
        }
      },
    },
    invalidFeedbackUsername: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.userToEdit.username.$dirty) return error;
        if (!this.$v.userToEdit.username.required) error = "required";
        if (!this.$v.userToEdit.username.minLength) error = "min";
        return error;
      },
    },
    invalidFeedbackFirstName: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.userToEdit.firstName.$dirty) return error;
        if (!this.$v.userToEdit.firstName.required) error = "required";
        return error;
      },
    },
    invalidFeedbackLastName: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.userToEdit.lastName.$dirty) return error;
        if (!this.$v.userToEdit.lastName.required) error = "required";
        return error;
      },
    },
    invalidFeedbackSpeciality: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.userToEdit.medicalSpecialtyId.$dirty) return error;
        if (!this.$v.userToEdit.medicalSpecialtyId.required) error = "required";
        return error;
      },
    },
    invalidFeedbackUnit: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.userToEdit.units.$dirty) return error;
        if (!this.$v.userToEdit.units.required) error = "required";
        return error;
      },
    },
    countriesWithCode() {
      return this.countries.map(country => ({
        ...country,
        titleAndCode: `${country.phoneCode} `
      }));
    }
  },
  methods: {
    invalidUserName(value) {
      if (value) {
        switch (value) {
          case "required":
            return this.$t(`validation.required`, {
              field: this.$t("user.username"),
            });
          case "min":
            return this.$t(`validation.min`, {
              min: 4,
            });
        }
      } else return "";
    },
    selectInput(val) {},
    findUser() {
      let params = this.$route.params;
      this.$store.dispatch("user/findUser", params.id).then((user) => {
        this.$store.commit("user/SET_USER_TO_EDIT", user);
      });
    },
    preventMobileType(value) {
      if (this.userToEdit.mobile.length >= 11) {
        value.preventDefault();
        return;
      }
    },
    preventNationalType(evt) {
      const keysAllowed = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
      if (!keysAllowed.includes(evt.key)) {
        evt.preventDefault();
      }
    },
    countrySelected() {
      this.$set(this.userToEdit, "mobileCountryId", this.userToEdit.countryId);
      let selected = this.countries.find((c) => {
        return c._id === this.userToEdit.countryId;
      });
      
      if (selected["alpha_2"] === "AF") {
        this.mobileCountryId = this.countries.find((c) => {
          return c["alpha_2"] === "IR";
        })._id;
        selected.phoneCode = 98;
      } else {
        this.mobileCountryId = this.userToEdit.countryId;
      }
      this.userToEdit.mobiles.forEach((m) => {
        this.$set(m, "dial_code", selected["phoneCode"]);
      });
    },
    editUser() {
      if (!this.userToEdit.nationalCode) {
        this.$bvToast.toast(this.$t("toastification.ErrNationalCode"), {
            variant: "danger",
            solid: true,
          });
    return;
  }
      let payload = this.userToEdit;
      delete payload._id;
      payload = _(payload)
        .mapValues((value) =>
          _.isEmpty(value) & !Array.isArray(value) ? null : value
        )
        .value();
      delete payload.createdUserId;
      delete payload.createdAt;
      delete payload.updatedAt;
      delete payload.__v;
      delete payload.updatedUserId;
      delete payload.id;
      this.$store
        .dispatch("user/editUser", {
          items: payload,
          userId: this.$route.params.id,
        })
        .then((res) => {
          // console.log(res,'llll')
          this.$bvToast.toast(this.$t("toastification.submissionSucceed"), {
            variant: "success",
            solid: true,
          });
          this.$router.push({ name: "manageUsers" });
        })
        .catch((error) => {
          this.$bvToast.toast(this.$t("toastification.submissionFailed"), {
            variant: "danger",
            solid: true,
          });
        });
    },
    roleSelected(x) {
      this.otherDoctor = false;
      this.referralWayRole = this.referralWays.find((r) => {
        return r._id == this.userToEdit.referralWayId;
      });
      let referralRole;
      if (this.referralWayRole && this.referralWayRole.type !== "social") {
        if (
          this.referralWayRole &&
          this.referralWayRole.type !== "introducingـfriends"
        ) {
          referralRole = this.roles.find((r) => {
            return r.title == this.referralWayRole.type;
          });
          // this.userToEdit.referrerFullName = "";
          this.userToEdit.referrerAddress = "";
        }
        let roles = [];
        referralRole ? roles.push(referralRole._id) : "";
        this.$store
          .dispatch("user/searchUsers", {
            roles,
          })
          .then((res) => {
            if (
              this.referralWayRole &&
              this.referralWayRole.type === "referral_doctor"
            ) {
              res.push({ firstName: "", lastName: "سایر", _id: "0" });
              this.$store.commit("user/SET_REFERRER_USERS", res);
            } else {
              this.$store.commit("user/SET_REFERRER_USERS", res);
            }
          });
      }
    },
  },
  mounted() {
    let el = this.$refs.gender;
    if (el) {
      el.$el.focus();
    }
  },
};
</script>
<style scoped>
input:read-only {
  background-color: #ffffff;
  border: 1px solid #cccccc;
  padding: 5px;
}
</style>
